const moduleWidthSelect = 'moduleWidth';
const autoPlayCheckbox = 'autoPlay';
const autoPlayInterval = 'intervalTime';
const leaveGapCheckbox = 'leaveGap';
const moduleTypeSelect = 'moduleType';
const resizingOptionsSelect = 'resizingOption';
const gapSelect = 'posterGap';
const posterTypeSelect = 'posterType';
const editable = 'editable';
const animation = 'animation';
const entranceUuid = 'entranceUuid';
const hoverEffectUuid = 'hoverEffectUuid';

const moduleStyle = 'moduleStyle';
const topPadding = 'topPadding';
const bottomPadding = 'bottomPadding';
const backgroundType = 'backgroundType';
const fullWidth = 'fullWidth';
const marginToTop = 'marginToTop';
const marginToBottom = 'marginToBottom';
const marginToLeft = 'marginToLeft';
const marginToRight = 'marginToRight';
const backgroundColor = 'backgroundColor';

const images = 'images';
const products = 'products';

const imageName = 'name';
const imageImage = 'image';
const imageSetting = 'imageSetting';
const imageImageLink = 'imageLink';
const imageBackground = 'background';
const imageAutoplayEnabled = 'autoplayEnabled';
const imageMute = 'mute';
const layers = 'layers';
const layerType = 'layerType';
const buttonThemeUuid = 'buttonThemeUuid';
const buttonText = 'buttonText';
const buttonLink = 'linkModule';

const positionOption = 'positionOption';
const marginToHCenter = 'marginToHCenter';
const marginToVCenter = 'marginToVCenter';

const content = 'content';
const text = 'text';
const textBoxWidth = 'textBoxWidth';
const fontSizeMultiply = 'fontSizeMultiply';
const textAlignment = 'textAlignment';
const imageWidth = 'imageWidth';
const imageLayerImage = 'image';
const imageLayerLinkModule = 'linkModule';

const productToShow = 'productToShow';
const leaveGap = 'leaveGap';
const scrollOut = 'scrollOut';
const actionButtonTheme = 'actionButtonTheme';

const moduleText = 'moduleText';
const productNameColor = 'productNameColor';
const bodyTextColor = 'bodyTextColor';
const listPriceColor = 'listPriceColor';
const otherPriceColor = 'otherPriceColor';

const contentPage = 'contentPage';
const subtitle = 'subtitle';
const summary = 'summary';
const contentImage = 'image';
const contentPages = 'contentPages';

const contentPagesToShow = 'contentPagesToShow';
const h1TagEnabled = 'h1TagEnabled';
const layoutOption = 'layoutOption';
const submitButtonText = 'submitButtonText';
const fields = 'fields';
const tacs = 'tacs';
const subscriptionFormStyle = 'subscriptionFormStyle';
const outlineColor = 'outlineColor';
const tacTextAndIconColor = 'tacTextAndIconColor';

const posterType = 'posterType';
const posterGap = 'posterGap';
const overflowOption = 'overflowOption';

const subtitleColor = 'subtitleColor';
const contentPageNameColor = 'contentPageNameColor';
const contentPageSummaryColor = 'contentPageSummaryColor';

const tabs = 'tabs';
const title = 'title';

const posters = 'posters';

const tabStyle = 'tabStyle';
const gapUnderTab = 'gapUnderTab';
const activeTabColor = 'activeTabColor';
const regularTabColor = 'regularTabColor';

const ETextCopyTrigger = 'TextCopyTrigger';

const name = 'name';

const alwaysOn = 'alwaysOn';
const beginDate = 'beginDate';
const beginTime = 'beginTime';
const endDate = 'endDate';
const endTime = 'endTime';

const _timeSettings = '_timeSettings';
//const contentLinkModule = 'linkModule';

const onResizing = 'onResizing';

const iframeLink = 'linkModule';
const moduleHeight = 'moduleHeight';
const moduleHeightUnit = 'moduleHeightUnit';

export {
  ETextCopyTrigger,
  _timeSettings,
  actionButtonTheme,
  activeTabColor,
  alwaysOn,
  animation,
  autoPlayCheckbox,
  autoPlayInterval,
  backgroundColor,
  backgroundType,
  beginDate,
  beginTime,
  bodyTextColor,
  bottomPadding,
  buttonLink,
  buttonText,
  buttonThemeUuid,
  content,
  contentImage,
  contentPage,
  contentPageNameColor,
  contentPageSummaryColor,
  contentPages,
  contentPagesToShow,
  editable,
  endDate,
  endTime,
  entranceUuid,
  fields,
  fontSizeMultiply,
  fullWidth,
  gapSelect,
  gapUnderTab,
  h1TagEnabled,
  //contentLinkModule,
  hoverEffectUuid,
  iframeLink,
  imageAutoplayEnabled,
  imageBackground,
  imageImage,
  imageImageLink,
  imageLayerImage,
  imageLayerLinkModule,
  imageMute,
  imageName,
  imageSetting,
  imageWidth,
  images,
  layerType,
  layers,
  layoutOption,
  leaveGap,
  leaveGapCheckbox,
  listPriceColor,
  marginToBottom,
  marginToHCenter,
  marginToLeft,
  marginToRight,
  marginToTop,
  marginToVCenter,
  moduleHeight,
  moduleHeightUnit,
  moduleStyle,
  moduleText,
  moduleTypeSelect,
  moduleWidthSelect,
  name,
  onResizing,
  otherPriceColor,
  outlineColor,
  overflowOption,
  positionOption,
  posterGap,
  posterType,
  posterTypeSelect,
  posters,
  productNameColor,
  productToShow,
  products,
  regularTabColor,
  resizingOptionsSelect,
  scrollOut,
  submitButtonText,
  subscriptionFormStyle,
  subtitle,
  subtitleColor,
  summary,
  tabStyle,
  tabs,
  tacTextAndIconColor,
  tacs,
  text,
  textAlignment,
  textBoxWidth,
  title,
  topPadding,
};
